import script from "./image-band.vue?vue&type=script&lang=js"
export * from "./image-band.vue?vue&type=script&lang=js"

import "./image-band.vue?vue&type=style&index=0&id=35ba0c5e&lang=scss"

const __exports__ = script;

export default __exports__